export default {
    2023: {
        101: '#4f25d2', //FDP
        102: '#FF9B00', //Mitte
        103: '#DC0018', //SP
        104: '#3b745d', //SVP
        105: '#150099', //LPS
        106: '#a6dfe7', //LdU
        107: '#007D8e', //EVP
        108: '#58c2d1', //CSP
        109: '#a4b315', //GLP
        110: '#8A156e', //PdA
        111: '#cd35ab', //Sol.
        112: '#53bf17', //FGA
        113: '#399d50', //Grüne
        114: '#deb7f3', //SD
        115: '#a332de', //EDU
        116: '#530080', //Lega
        117: '#b964e6', //MCR
        120: '#f56a00', //CVP
        121: '#f3bf00', //BDP
        135: '#8e8e8e', //Übrige
        140: '#ccc', // 2. WG
        150: '#ccc', // 2. WG

        201: '#4f25d2', // FDP
        202: '#FF9B00', // Mitte
        203: '#DC0018', // SP
        204: '#3b745d', // SVP
        205: '#00A2B9', // Kleine Mittelpartei
        206: '#a4b315', // GLP
        208: '#cd35ab', // Kleine Linksparteien
        209: '#399D50', // Grüne
        210: '#A332DE', // Kleine rechtsparteien
        220: '#f56a00', // CVP
        221: '#f3bf00', // BDP
        235: '#8e8e8e', // Übrige

        301: '#9f3039', // Linke und grüne Parteien
        302: '#ff9b00', // Kleine Mitteparteien und andere
        303: '#006f8a'  // Traditionelle bürgerliche und rechte Parteien
    },
    2019: {
        101: '#4f25d2', //FDP
        102: '#f56a00', //CVP
        103: '#DC0018', //SP
        104: '#3B745D', //SVP
        105: '#150099', //LPS
        106: '#a6dfe7', //LdU
        107: '#007d8e', //EVP
        108: '#58c2d1', //CSP
        109: '#a4b315', //GLP
        110: '#F3BF00', //BDP
        111: '#cd35ab', //PdA/Sol.
        112: '#53bf17', //FGA
        113: '#399d50', //GPS
        114: '#deb7f3', //SD
        115: '#a332de', //EDU
        116: '#CC8FED', //FPS
        117: '#530080', //Lega
        118: '#b964e6', //MCR
        135: '#8e8e8e', //Übrige
        140: '#ccc', // 2. WG
        150: '#ccc', // 2. WG

        201: '#4f25d2', // FDP
        202: '#FF9B00', // Mitte
        203: '#DC0018', // SP
        204: '#3b745d', // SVP
        205: '#00A2B9', // Kleine Mittelpartei
        206: '#a4b315', // GLP
        207: '#F3BF00', // BDP
        208: '#cd35ab', // Kleine Linksparteien
        209: '#399D50', // Grüne
        210: '#A332DE', // Kleine rechtsparteien
        235: '#8e8e8e', // Übrige

        301: '#9f3039', // Linke und grüne Parteien
        302: '#ff9b00', // Kleine Mitteparteien und andere
        303: '#006f8a'  // Traditionelle bürgerliche und rechte Parteien
    }
}